import isClient from '@equifax-ui/utils/browser/isClient'

import { MICROSOFT_CLIENT_ID_LABEL } from '@/constants/api'

import { newRelicNotifyError } from './trackingNewRelic'

export const setMicrosoftClickId = () => {
  const urlParams = new URLSearchParams(window.location.search)
  const mClickId = urlParams.get('msclkid')

  const microsoftClickId = sessionStorage.getItem(MICROSOFT_CLIENT_ID_LABEL)

  if (mClickId && !microsoftClickId) {
    sessionStorage.setItem(MICROSOFT_CLIENT_ID_LABEL, mClickId)
  }
}

export const getMicrosoftClientId = async () => {
  if (!isClient()) return

  try {
    const valueFromStorage = sessionStorage.getItem(MICROSOFT_CLIENT_ID_LABEL)

    return valueFromStorage || ''
  } catch (error) {
    console.error(error)
    newRelicNotifyError(`Error getMicrosoftClientId: ${error}`)
    return undefined
  }
}
